export const sleep = async (ms: number) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(true), ms);
  });
};



// WEBPACK FOOTER //
// ./src/app/_helpers/sleep.ts